import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

// Safe JSON parse — never throws, returns null on any error
function safeParseJSON(str) {
  if (!str || str === 'undefined' || str === 'null') return null;
  try { return JSON.parse(str); } catch { return null; }
}

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Clear any stale keys from older versions of the app
    const oldAdmin = localStorage.getItem('admin');
    if (oldAdmin) {
      localStorage.removeItem('admin');  // remove old 'admin' key
    }

    const token = localStorage.getItem('token');
    const saved = safeParseJSON(localStorage.getItem('user'));

    if (token && saved && saved.id) {
      setUser(saved);
    } else {
      // Clear potentially corrupt state
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth?action=login', { email, password });
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user',  JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('admin'); // clean up any old key too
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
